import {
  SOCIETY_PORTAL, DASHBOARD, SOCIETY_PORTAL_WINGS,
  SOCIETY_PORTAL_MEMBERS_OWNERS, SOCIETY_PORTAL_MEMBERS_TENANTS, SOCIETY_PORTAL_MEMBERS_FAMILY,
  SOCIETY_PORTAL_MEMBERS_ADD_OWNER, SOCIETY_PORTAL_MEMBERS_ADD_TENANT, SOCIETY_PORTAL_MEMBERS_ADD_FAMILY,
  SOCIETY_PORTAL_INVOICES, SOCIETY_PORTAL_CREDIT_NOTES, SOCIETY_PORTAL_DEBIT_NOTES, SOCIETY_PORTAL_RECEIPTS,
  SOCIETY_PORTAL_VENDORS, SOCIETY_PORTAL_VENDOR_BILLS, SOCIETY_PORTAL_VENDOR_PAYMENTS, SOCIETY_PORTAL_VENDOR_SETTINGS, SOCIETY_PORTAL_VENDOR_VISITS,
  SOCIETY_PORTAL_SETUP_METER_READING,
  SOCIETY_PORTAL_SETUP_OPENING_BALANCE,
  SOCIETY_PORTAL_ACCOUNTS_JOURNAL,
  SOCIETY_PORTAL_ACCOUNTS_CHART_OF_ACCOUNTS,
  SOCIETY_PORTAL_ACCOUNTS_OPENING,
  SOCIETY_PORTAL_ACCOUNTS_CLOSING,
  SOCIETY_PORTAL_ACCOUNTS_MEMBER_DAYBOOK,
  SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS,
  SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK,
  SOCIETY_PORTAL_ACCOUNTS_INVESTMENTS,
  SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_INCOME_EXPENDITURE,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_BALANCE_SHEET,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_TRIAL_BALANCE,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_GROUP_LEDGER,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_ACCOUNT_LEDGER,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME_EXPENDITURE,
  SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_EXPENDITURE,
  SOCIETY_PORTAL_REPORTS_MEMBER_LEDGER,
  SOCIETY_PORTAL_REPORTS_INVOICE,
  SOCIETY_PORTAL_REPORTS_INVOICE_AGING,
  SOCIETY_PORTAL_REPORTS_INTEREST,
  SOCIETY_PORTAL_REPORTS_RECEIPT,
  SOCIETY_PORTAL_REPORTS_CD_NOTE,
  SOCIETY_PORTAL_REPORTS_GST,
  SOCIETY_PORTAL_REPORTS_RECONCILIATION,
  SOCIETY_PORTAL_SETUP_BANK_ACCOUNTS,
  SOCIETY_PORTAL_ROLES,
  SOCIETY_PORTAL_EMPLOYEES,
  SOCIETY_PORTAL_ATTENDANCE_REPORT,
  SOCIETY_PORTAL_PUNCH_ATTENDANCE,
  SOCIETY_PORTAL_MY_ATTENDANCE,
  SOCIETY_PORTAL_MANAGE_ATTENDANCE,
  SOCIETY_PORTAL_SHIFTS,
  SOCIETY_PORTAL_SHIFT_ASSIGNMENTS,
  SOCIETY_PORTAL_COMPLAINTS,
  SOCIETY_PORTAL_COMPLAINT_CATEGORIES,
  SOCIETY_PORTAL_MY_COMPLAINTS,
  SOCIETY_PORTAL_SHARE_CERTIFICATES,
  SOCIETY_PORTAL_TASK_PROJECTS,
  SOCIETY_PORTAL_TASKS_LIST,
  SOCIETY_PORTAL_COMMITTEE_OVERSIGHT,
  SOCIETY_PORTAL_TASKS_DASHBOARD,
  SOCIETY_PORTAL_NOTICES,
  SOCIETY_PORTAL_NOTICE_BOARD,
  SOCIETY_PORTAL_WORKING_DOCUMENTS,
  SOCIETY_PORTAL_VISITORS,
  SOCIETY_PORTAL_VISITORS_ADD,
  SOCIETY_PORTAL_VISITS,
  SOCIETY_PORTAL_PRE_APPROVALS,
  SOCIETY_PORTAL_GATE_PASSES,
  SOCIETY_PORTAL_DELIVERIES,
  SOCIETY_PORTAL_CABS,
  SOCIETY_PORTAL_VMS_ACTIVITY_LOGS,
  SOCIETY_PORTAL_VMS_SETTINGS,
  SOCIETY_PORTAL_MY_HOME,
  SOCIETY_PORTAL_MY_BILLS,
  SOCIETY_PORTAL_MY_PAYMENTS,
  SOCIETY_PORTAL_MY_LEDGER,
} from "../../Routing/routes";
import { PERMISSIONS, MEMBER_PORTAL_PERMISSIONS } from "../../consts/permissions";
import { canAny } from "../../utils/helpers/can";

/**
 * Society Portal Sidebar Menu Configuration
 * Organized by modules, submodules, and sub-submodules (3 levels)
 *
 * Structure:
 * - Level 1: Module (e.g., Finance)
 * - Level 2: Submodule (e.g., Manage Credit Note)
 * - Level 3: Sub-submodule (e.g., Credit Notes, Settings)
 */

export const menuConfig = [
  // Dashboard - Single item (no submodules)
  {
    id: "dashboard",
    title: "Dashboard",
    icon: "solar:home-smile-angle-outline",
    path: SOCIETY_PORTAL + DASHBOARD,
    type: "single",
  },

  // Member self-service. Sits directly under the dashboard because for a
  // resident this is the whole product; the admin modules below are noise.
  {
    id: "my-home",
    title: "My Home",
    icon: "hugeicons:home-01",
    type: "dropdown",
    submodules: [
      {
        id: "my-overview",
        title: "Overview",
        icon: "solar:home-smile-angle-outline",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_HOME,
      },
      {
        id: "my-bills",
        title: "My Bills",
        icon: "hugeicons:invoice-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_BILLS,
      },
      {
        id: "my-payments",
        title: "My Payments",
        icon: "mdi:receipt-text-check-outline",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_PAYMENTS,
      },
      {
        id: "my-ledger",
        title: "Statement of Account",
        icon: "hugeicons:notebook-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_LEDGER,
      },
      {
        id: "my-complaints-shortcut",
        title: "My Complaints",
        icon: "hugeicons:message-notification-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_COMPLAINTS,
      },
      {
        id: "my-notice-board",
        title: "Notice Board",
        icon: "mdi:bulletin-board",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_NOTICE_BOARD,
      },
      {
        id: "my-documents",
        title: "Society Documents",
        icon: "hugeicons:folder-file-storage",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_WORKING_DOCUMENTS,
      },
    ],
  },

  // My Society Module
  {
    id: "my-society",
    title: "My Society",
    icon: "hugeicons:building-03",
    type: "dropdown",
    submodules: [
      {
        id: "society-profile",
        title: "Society Profile",
        icon: "hugeicons:building-06",
        path: SOCIETY_PORTAL + "/society-profile",
      },
      {
        id: "wings",
        title: "Wings",
        icon: "hugeicons:structure-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_WINGS,
      },
      {
        id: "working-documents",
        title: "Working Documents",
        icon: "hugeicons:folder-file-storage",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_WORKING_DOCUMENTS,
      },
    ],
  },

  // Setup and Records Module
  {
    id: "setup-and-records",
    title: "Setup and Records",
    icon: "hugeicons:settings-01",
    type: "dropdown",
    submodules: [
      {
        id: "invoice-setup",
        title: "Invoice Setup",
        type: "nested",
        children: [
          {
            id: "billing-types",
            title: "Billing Types",
            icon: "hugeicons:invoice-02",
            path: SOCIETY_PORTAL + "/setup/billing-types",
          },
          {
            id: "document-series",
            title: "Document Series",
            icon: "hugeicons:note-01",
            path: SOCIETY_PORTAL + "/setup/document-series",
          },
          {
            id: "charge-heads",
            title: "Charge Heads",
            icon: "hugeicons:money-bag-02",
            path: SOCIETY_PORTAL + "/setup/charge-heads",
          },
          {
            id: "functional-setting",
            title: "Functional Setting",
            icon: "hugeicons:settings-02",
            path: SOCIETY_PORTAL + "/setup/functional-setting",
          },
          {
            id: "tax-rules",
            title: "Tax Rules",
            icon: "hugeicons:file-edit",
            path: SOCIETY_PORTAL + "/setup/tax-rules",
          },
          {
            id: "meter-reading",
            title: "Meter Reading",
            icon: "hugeicons:dashboard-speed-01",
            path: SOCIETY_PORTAL + SOCIETY_PORTAL_SETUP_METER_READING,
          },
          {
            id: "opening-balance",
            title: "Opening Balance",
            icon: "hugeicons:wallet-02",
            path: SOCIETY_PORTAL + SOCIETY_PORTAL_SETUP_OPENING_BALANCE,
          },
        ],
      },
      {
        id: "bank-accounts",
        title: "Bank Accounts",
        icon: "hugeicons:bank",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_SETUP_BANK_ACCOUNTS,
      },
      {
        id: "roles-permissions",
        title: "Roles & Permissions",
        icon: "hugeicons:shield-user",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ROLES,
      },
    ],
  },

  // Members Module
  {
    id: "members",
    title: "Members",
    icon: "hugeicons:user-03",
    type: "dropdown",
    submodules: [
      {
        id: "members-owners",
        title: "Owners",
        icon: "hugeicons:user-check-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_OWNERS,
        activePaths: [SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_OWNER],
      },
      {
        id: "members-tenants",
        title: "Tenants",
        icon: "hugeicons:user-switch",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_TENANTS,
        activePaths: [SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_TENANT],
      },
      {
        id: "members-family",
        title: "Family",
        icon: "hugeicons:user-group",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_FAMILY,
        activePaths: [SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_FAMILY],
      },
    ],
  },

  // Employees Module
  {
    id: "employees",
    title: "Employees",
    icon: "hugeicons:user-multiple-02",
    type: "dropdown",
    submodules: [
      {
        id: "employees-list",
        title: "Employees",
        icon: "hugeicons:user-multiple-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_EMPLOYEES,
      },
      {
        id: "employees-attendance",
        title: "Attendance Report",
        icon: "hugeicons:location-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ATTENDANCE_REPORT,
      },
    ],
  },

  // Attendance Module (employee self-service — punch in/out of a shift)
  {
    id: "attendance",
    title: "Attendance",
    icon: "hugeicons:clock-01",
    type: "dropdown",
    submodules: [
      {
        id: "attendance-punch",
        title: "Punch In / Out",
        icon: "hugeicons:touch-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_PUNCH_ATTENDANCE,
      },
      {
        id: "attendance-history",
        title: "My Attendance",
        icon: "hugeicons:calendar-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_ATTENDANCE,
      },
      {
        id: "attendance-manage",
        title: "Manage Attendance",
        icon: "hugeicons:user-check-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MANAGE_ATTENDANCE,
      },
    ],
  },

  // Shifts — the shift definitions, and who is assigned to which. Most
  // assigning happens on the employee form; this screen is for the rest.
  {
    id: "shifts",
    title: "Shifts",
    icon: "hugeicons:time-schedule",
    type: "dropdown",
    submodules: [
      {
        id: "shift-definitions",
        title: "Shift Setup",
        icon: "hugeicons:time-schedule",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_SHIFTS,
      },
      {
        id: "shift-assignments",
        title: "Shift Assignments",
        icon: "hugeicons:user-switch",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_SHIFT_ASSIGNMENTS,
      },
    ],
  },

  // Complaints Module
  {
    id: "complaints",
    title: "Complaints",
    icon: "hugeicons:message-notification-01",
    type: "dropdown",
    submodules: [
      {
        id: "my-complaints",
        title: "My Complaints",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_MY_COMPLAINTS,
      },
      {
        id: "complaints-list",
        title: "All Complaints",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_COMPLAINTS,
      },
      {
        id: "complaint-categories",
        title: "Categories",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_COMPLAINT_CATEGORIES,
      },
    ],
  },

  // Notices & Circulars Module
  {
    id: "notices",
    title: "Notices & Circulars",
    icon: "hugeicons:megaphone-01",
    type: "dropdown",
    submodules: [
      {
        id: "notice-board",
        title: "Notice Board",
        icon: "hugeicons:notification-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_NOTICE_BOARD,
      },
      {
        id: "notices-list",
        title: "All Notices",
        icon: "hugeicons:note-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_NOTICES,
      },
    ],
  },

  // Visitor Management Module (VMS).
  // Ordered by how often the gate desk reaches for them: the live visit flow
  // first, then the standing authorisations, then the logs and configuration.
  {
    id: "visitors",
    title: "Visitor Management",
    icon: "hugeicons:user-multiple-02",
    type: "dropdown",
    submodules: [
      {
        id: "visits-list",
        title: "Visits",
        icon: "hugeicons:door-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VISITS,
      },
      {
        id: "visitors-list",
        title: "Visitors",
        icon: "hugeicons:user-list",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VISITORS,
      },
      {
        id: "visitors-add",
        title: "Register Visitor",
        icon: "hugeicons:user-add-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VISITORS_ADD,
      },
      {
        id: "pre-approvals-list",
        title: "Pre-approvals",
        icon: "hugeicons:calendar-check-in-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_PRE_APPROVALS,
      },
      {
        id: "gate-passes-list",
        title: "Gate Passes",
        icon: "hugeicons:id",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_GATE_PASSES,
      },
      {
        id: "deliveries-list",
        title: "Deliveries",
        icon: "hugeicons:package",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_DELIVERIES,
      },
      {
        id: "cabs-list",
        title: "Cabs",
        icon: "hugeicons:taxi",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_CABS,
      },
      {
        id: "vms-activity-logs",
        title: "Activity Log",
        icon: "hugeicons:clock-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VMS_ACTIVITY_LOGS,
      },
      {
        id: "vms-settings",
        title: "VMS Settings",
        icon: "hugeicons:settings-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VMS_SETTINGS,
      },
    ],
  },

  // Vendors Module
  {
    id: "vendors",
    title: "Vendors",
    icon: "hugeicons:store-01",
    type: "dropdown",
    submodules: [
      {
        id: "vendor-list",
        title: "Vendor List",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VENDORS,
      },
      {
        id: "vendor-bills",
        title: "Vendor Bills",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VENDOR_BILLS,
      },
      {
        id: "vendor-payments",
        title: "Vendor Payments",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VENDOR_PAYMENTS,
      },
      {
        id: "vendor-visits",
        title: "Vendor Visits",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VENDOR_VISITS,
      },
      {
        id: "vendor-settings",
        title: "Vendor Settings",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_VENDOR_SETTINGS,
      },
    ],
  },

  // Task Management Module
  {
    id: "tasks",
    title: "Task Management",
    icon: "hugeicons:task-01",
    type: "dropdown",
    submodules: [
      // {
      //   id: "task-board",
      //   title: "Board",
      //   icon: "hugeicons:kanban",
      //   path: SOCIETY_PORTAL + SOCIETY_PORTAL_TASKS_BOARD,
      // },
      {
        id: "task-dashboard",
        title: "Dashboard",
        icon: "mdi:view-dashboard-outline",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_TASKS_DASHBOARD,
      },
      {
        id: "task-projects",
        title: "Projects",
        icon: "hugeicons:folder-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_TASK_PROJECTS,
      },
      {
        id: "task-list",
        title: "Task",
        icon: "hugeicons:task-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_TASKS_LIST,
      },
    ],
  },

  // Core committee: read-only oversight of member complaints and managers' tasks.
  {
    id: "committee-oversight",
    title: "Core Committee",
    icon: "mdi:account-group-outline",
    path: SOCIETY_PORTAL + SOCIETY_PORTAL_COMMITTEE_OVERSIGHT,
    type: "single",
  },

  // Finance Module
  {
    id: "finance",
    title: "Finance",
    icon: "hugeicons:invoice-03",
    type: "dropdown",
    submodules: [
      {
        id: "invoices",
        title: "Invoices",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_INVOICES,
      },
      {
        id: "credit-notes",
        title: "Credit Notes",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_CREDIT_NOTES,
      },
      {
        id: "debit-notes",
        title: "Debit Notes",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_DEBIT_NOTES,
      },
      {
        id: "receipts",
        title: "Receipts",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_RECEIPTS,
      },
    ],
  },

  // Accounts Module
  {
    id: "accounts",
    title: "Accounts",
    icon: "hugeicons:book-02",
    type: "dropdown",
    submodules: [
      {
        id: "accounts-chart-of-accounts",
        title: "Chart of Accounts",
        icon: "hugeicons:structure-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_CHART_OF_ACCOUNTS,
      },
      {
        id: "accounts-journal",
        title: "Journal",
        icon: "hugeicons:notebook-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_JOURNAL,
      },
      {
        id: "accounts-opening",
        title: "Opening",
        icon: "hugeicons:notebook-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_OPENING,
      },
      {
        id: "accounts-closing",
        title: "Closing",
        icon: "hugeicons:notebook-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_CLOSING,
      },
      {
        id: "accounts-member-daybook",
        title: "Member Daybook",
        icon: "hugeicons:book-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_MEMBER_DAYBOOK,
      },
      {
        id: "accounts-fixed-assets",
        title: "Fixed Assets",
        icon: "hugeicons:building-06",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS,
      },
      {
        id: "accounts-cash-and-bank",
        title: "Cash & Bank",
        icon: "hugeicons:bank",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK,
      },
      {
        id: "accounts-investments",
        title: "Investments",
        icon: "hugeicons:chart-increase",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_INVESTMENTS,
      },
      {
        id: "accounts-reconciliation",
        title: "Reconciliation",
        icon: "hugeicons:structure-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION,
      },
    ],
  },

  // Accounts Reports Module
  {
    id: "accounts-reports",
    title: "Accounts Reports",
    icon: "hugeicons:chart-line-data-01",
    type: "dropdown",
    submodules: [
      {
        id: "report-income-expenditure",
        title: "Income & Expenditure",
        icon: "hugeicons:money-exchange-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_INCOME_EXPENDITURE,
      },
      {
        id: "report-balance-sheet",
        title: "Balance Sheet",
        icon: "hugeicons:invoice-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_BALANCE_SHEET,
      },
      {
        id: "report-trial-balance",
        title: "Trial Balance",
        icon: "mdi:scale-balance",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_TRIAL_BALANCE,
      },
      {
        id: "report-group-ledger",
        title: "Group Ledger",
        icon: "hugeicons:notebook-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_GROUP_LEDGER,
      },
      {
        id: "report-account-ledger",
        title: "Account Ledger",
        icon: "hugeicons:notebook-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_ACCOUNT_LEDGER,
      },
      {
        id: "report-month-wise-ie",
        title: "Month-wise Income & Expenditure",
        icon: "hugeicons:calendar-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME_EXPENDITURE,
      },
      {
        id: "report-monthly-income",
        title: "Monthly Income",
        icon: "hugeicons:calendar-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME,
      },
      {
        id: "report-monthly-expenditure",
        title: "Monthly Expenditure",
        icon: "hugeicons:calendar-04",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_EXPENDITURE,
      },
    ],
  },

  // Compliance Module
  {
    id: "compliance",
    title: "Compliance",
    icon: "hugeicons:certificate-01",
    type: "dropdown",
    submodules: [
      {
        id: "share-certificates",
        title: "Share Certificates",
        icon: "hugeicons:certificate-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_SHARE_CERTIFICATES,
      },
    ],
  },

  // Reports Module
  {
    id: "reports",
    title: "Reports",
    icon: "hugeicons:chart-line-data-01",
    type: "dropdown",
    submodules: [
      {
        id: "reports-invoice",
        title: "Invoice Report",
        icon: "hugeicons:invoice-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_INVOICE,
      },
      {
        id: "reports-invoice-aging",
        title: "Invoice Aging Report",
        icon: "hugeicons:clock-01",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_INVOICE_AGING,
      },
      {
        id: "reports-interest",
        title: "Interest Calculation",
        icon: "hugeicons:percent-circle",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_INTEREST,
      },
      {
        id: "reports-receipt",
        title: "Receipt Report",
        icon: "hugeicons:wallet-02",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_RECEIPT,
      },
      {
        id: "reports-gst",
        title: "GST Report",
        icon: "hugeicons:file-edit",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_GST,
      },
      {
        id: "reports-reconciliation",
        title: "Reconciliation Report",
        icon: "hugeicons:structure-03",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_RECONCILIATION,
      },
      {
        id: "reports-cd-note",
        title: "Credit/Debit Note Report",
        icon: "hugeicons:note-edit",
        path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_CD_NOTE,
      },
      // {
      //   id: "reports-member-ledger",
      //   title: "Member Ledger Report",
      //   icon: "hugeicons:note-01",
      //   path: SOCIETY_PORTAL + SOCIETY_PORTAL_REPORTS_MEMBER_LEDGER,
      // },
    ],
  },

];

/**
 * Sidebar visibility, keyed by menu item id.
 *
 * An entry is shown when the user holds ANY of the listed codes — the same
 * canAny() check, against the same permission codes, that Routing/SocietyPortal/
 * Routers.js guards the destination screen with. Keep the two in step: a visible
 * entry whose route is guarded just walks the user into a 403 screen.
 *
 * Ids deliberately absent are the ones whose routes carry no guard either —
 * the Dashboard, the profile, the employee attendance self-service and the
 * notice board.
 */
export const MENU_PERMISSIONS = {
  // My Home — the resident portal, one permission per page, all granted to
  // RESIDENT by seeder. A resident role is never given complaint.read /
  // society.read just to reach its own bills (see RESIDENT_PORTAL_OVERRIDES
  // for why that matters). The routes and /api/member/* are gated on the same
  // codes. The "my-home" container itself carries none: it disappears when
  // every page inside it is pruned.
  "my-overview": [PERMISSIONS.MEMBER_PORTAL_OVERVIEW],
  "my-bills": [PERMISSIONS.MEMBER_PORTAL_BILLS],
  "my-payments": [PERMISSIONS.MEMBER_PORTAL_PAYMENTS],
  "my-ledger": [PERMISSIONS.MEMBER_PORTAL_LEDGER],
  "my-complaints-shortcut": [PERMISSIONS.MEMBER_PORTAL_COMPLAINTS],
  "my-notice-board": [PERMISSIONS.MEMBER_PORTAL_NOTICE_BOARD],
  // Resident entry to Working Documents. Gated on a portal code so it only
  // appears inside My Home for residents; the API checks society_document.read.
  "my-documents": [PERMISSIONS.MEMBER_PORTAL_OVERVIEW],

  // My Society
  "society-profile": [PERMISSIONS.SOCIETY_READ],
  wings: [PERMISSIONS.WING_READ],
  "working-documents": [PERMISSIONS.SOCIETY_DOCUMENT_READ],

  // Setup and Records
  "billing-types": [PERMISSIONS.INVOICE_TYPE_READ],
  "document-series": [PERMISSIONS.DOCUMENT_SERIES_READ],
  "charge-heads": [PERMISSIONS.TARIFF_HEAD_READ],
  "functional-setting": [PERMISSIONS.INVOICE_SETTING_READ],
  "tax-rules": [PERMISSIONS.TAX_RULE_READ],
  "meter-reading": [PERMISSIONS.METER_READING_READ],
  "opening-balance": [PERMISSIONS.OPENING_BALANCE_READ],
  "bank-accounts": [PERMISSIONS.SOCIETY_BANK_READ],
  "roles-permissions": [PERMISSIONS.ROLE_READ],

  // Members
  "members-owners": [PERMISSIONS.ENTITY_READ],
  "members-tenants": [PERMISSIONS.OCCUPANT_READ],
  "members-family": [PERMISSIONS.OCCUPANT_READ],

  // Employees
  "employees-list": [PERMISSIONS.EMPLOYEE_READ],
  "employees-attendance": [PERMISSIONS.LOGIN_HISTORY_READ],
  "attendance-manage": [PERMISSIONS.ATTENDANCE_READ_ALL],

  // Shifts
  "shift-definitions": [PERMISSIONS.SHIFT_READ],
  "shift-assignments": [PERMISSIONS.SHIFT_READ],

  // Complaints — "My Complaints" is the resident's own list (/api/member/complaints)
  "my-complaints": [PERMISSIONS.MEMBER_PORTAL_COMPLAINTS],
  "complaints-list": [PERMISSIONS.COMPLAINT_READ],
  "complaint-categories": [PERMISSIONS.COMPLAINT_READ],

  // Notices — the board itself stays ungated
  "notices-list": [PERMISSIONS.NOTICE_READ],

  // Visitor Management — same codes as the VMS routes in Routers.js. These were
  // missing, which showed the whole module to every account, including
  // residents holding no vms.* code at all.
  "visits-list": [PERMISSIONS.VMS_VISITOR_READ],
  "visitors-list": [PERMISSIONS.VMS_VISITOR_READ],
  "visitors-add": [PERMISSIONS.VMS_VISITOR_CREATE],
  "pre-approvals-list": [PERMISSIONS.VMS_PRE_APPROVAL_READ],
  "gate-passes-list": [PERMISSIONS.VMS_GATE_PASS_READ],
  "deliveries-list": [PERMISSIONS.VMS_DELIVERY_READ],
  "cabs-list": [PERMISSIONS.VMS_CAB_READ],
  "vms-activity-logs": [PERMISSIONS.VMS_VISITOR_LOG_READ],
  "vms-settings": [PERMISSIONS.VMS_SETTINGS_READ],

  // Vendors
  "vendor-list": [PERMISSIONS.VENDOR_READ],
  "vendor-bills": [PERMISSIONS.VENDOR_BILL_READ],
  "vendor-payments": [PERMISSIONS.VENDOR_PAYMENT_READ],
  "vendor-visits": [PERMISSIONS.VENDOR_READ],
  "vendor-settings": [PERMISSIONS.VENDOR_SETTING_READ],

  // Tasks
  "task-dashboard": [PERMISSIONS.TASK_DASHBOARD],
  "task-projects": [PERMISSIONS.TASK_READ],
  "task-list": [PERMISSIONS.TASK_READ],
  "committee-oversight": [PERMISSIONS.COMMITTEE_OVERSIGHT],
  "task-board": [PERMISSIONS.TASK_READ],

  // Finance
  invoices: [PERMISSIONS.INVOICE_READ],
  "credit-notes": [PERMISSIONS.CREDIT_NOTE_READ],
  "debit-notes": [PERMISSIONS.DEBIT_NOTE_READ],
  receipts: [PERMISSIONS.RECEIPT_READ],

  // Accounts
  "accounts-chart-of-accounts": [PERMISSIONS.CHART_OF_ACCOUNT_READ],
  "accounts-journal": [PERMISSIONS.JOURNAL_READ],
  "accounts-opening": [PERMISSIONS.OPENING_BALANCE_READ],
  "accounts-closing": [PERMISSIONS.CLOSING_READ],
  "accounts-member-daybook": [PERMISSIONS.MEMBER_DAYBOOK_READ],
  "accounts-fixed-assets": [PERMISSIONS.FIXED_ASSET_READ],
  "accounts-cash-and-bank": [PERMISSIONS.CASH_BANK_READ],
  "accounts-investments": [PERMISSIONS.INVESTMENT_READ],
  "accounts-reconciliation": [PERMISSIONS.RECONCILIATION_READ],

  // Accounts Reports
  "report-income-expenditure": [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
  "report-balance-sheet": [PERMISSIONS.BALANCE_SHEET_REPORT_VIEW],
  "report-trial-balance": [PERMISSIONS.TRIAL_BALANCE_REPORT_VIEW],
  "report-group-ledger": [PERMISSIONS.GENERAL_LEDGER_REPORT_VIEW],
  "report-account-ledger": [PERMISSIONS.GENERAL_LEDGER_REPORT_VIEW],
  "report-monthly-income": [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
  "report-month-wise-ie": [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],
  "report-monthly-expenditure": [PERMISSIONS.INCOME_EXPENDITURE_REPORT_VIEW],

  // Compliance
  "share-certificates": [PERMISSIONS.SHARE_CERTIFICATE_READ],

  // Reports
  "reports-invoice": [PERMISSIONS.INVOICE_REPORT_VIEW],
  "reports-invoice-aging": [PERMISSIONS.INVOICE_AGING_REPORT_VIEW],
  "reports-interest": [PERMISSIONS.INTEREST_REPORT_VIEW],
  "reports-receipt": [PERMISSIONS.RECEIPT_REPORT_VIEW],
  "reports-gst": [PERMISSIONS.GST_REPORT_VIEW],
  "reports-reconciliation": [PERMISSIONS.RECONCILIATION_REPORT_VIEW],
  "reports-cd-note": [PERMISSIONS.CD_NOTE_REPORT_VIEW],
  "reports-member-ledger": [PERMISSIONS.MEMBER_LEDGER_REPORT_VIEW],
};

/**
 * Staff entries a resident must not see, even though the RESIDENT role holds
 * the read code that gates them.
 *
 * A resident's own screens genuinely need society.read (the header loads the
 * society profile), wing.read and flat.read (the visitor pre-approval pickers)
 * and complaint.read (viewing their own complaint). Those same codes gate the
 * staff screens below, so a resident used to get "My Society", "All
 * Complaints" and "Categories" in the sidebar — along with the employee
 * punch-in screens, which carry no permission at all.
 *
 * Revoking the reads would break the resident screens, and every staff and
 * committee role holds them too, so re-gating the entries outright would hide
 * them from read-only staff. Instead, holding any member_portal.* code — what
 * marks a resident portal — switches these entries to a staff-level
 * requirement. A staff account never holds one, so nothing changes for it; a
 * pure resident sees none of these; a committee member who is also granted the
 * resident portal keeps whatever their staff permissions still justify.
 *
 * An empty list means "never shown to a portal holder".
 */
export const RESIDENT_PORTAL_OVERRIDES = {
  // The admin dashboard reads society-wide figures on society.read (see
  // dashboardRoutes); a resident lands on My Home instead (Routers.js).
  dashboard: [PERMISSIONS.SOCIETY_READ],
  "society-profile": [PERMISSIONS.SOCIETY_UPDATE],
  wings: [PERMISSIONS.WING_CREATE, PERMISSIONS.WING_UPDATE, PERMISSIONS.WING_DELETE],
  "complaints-list": [
    PERMISSIONS.COMPLAINT_UPDATE,
    PERMISSIONS.COMPLAINT_ASSIGN,
    PERMISSIONS.COMPLAINT_STATUS_CHANGE,
    PERMISSIONS.COMPLAINT_DELETE,
  ],
  "complaint-categories": [
    PERMISSIONS.COMPLAINT_UPDATE,
    PERMISSIONS.COMPLAINT_ASSIGN,
    PERMISSIONS.COMPLAINT_STATUS_CHANGE,
    PERMISSIONS.COMPLAINT_DELETE,
  ],
  // A portal holder already has "My Complaints" inside My Home; the copy under
  // the staff Complaints module would otherwise keep that module alive for a
  // resident who holds nothing else in it.
  "my-complaints": [],
  // Employee self-service; a resident has no shift to punch.
  "attendance-punch": [],
  "attendance-history": [],
  // A portal holder reads the board from My Home, on member_portal.notice_board;
  // the ungated copy under Notices & Circulars is for staff.
  "notice-board": [],
  // Residents reach the same page from My Home > Society Documents.
  "working-documents": [],
};

const isVisible = (item, userPermissions) => {
  const holdsPortal = canAny(userPermissions, MEMBER_PORTAL_PERMISSIONS);
  const override = holdsPortal ? RESIDENT_PORTAL_OVERRIDES[item.id] : undefined;
  if (override !== undefined) return override.length > 0 && canAny(userPermissions, override);
  const required = MENU_PERMISSIONS[item.id];
  if (!required) return true;
  return canAny(userPermissions, required);
};

/**
 * Prune the menu to what this user may actually open.
 *
 * Applied depth-first, so a module whose every child was pruned disappears
 * too — an "Accounts" header that opens onto nothing is worse than no header.
 * A module carrying its own path (a "single") is kept on its own permission.
 */
export const filterMenu = (items, userPermissions = []) =>
  (items || []).reduce((out, item) => {
    if (!isVisible(item, userPermissions)) return out;

    const children = item.children ? filterMenu(item.children, userPermissions) : null;
    const submodules = item.submodules ? filterMenu(item.submodules, userPermissions) : null;

    // A container is only worth showing if something inside it survived.
    const isContainer = Array.isArray(item.children) || Array.isArray(item.submodules);
    if (isContainer && !item.path) {
      const kept = (children?.length || 0) + (submodules?.length || 0);
      if (kept === 0) return out;
    }

    out.push({
      ...item,
      ...(children ? { children } : {}),
      ...(submodules ? { submodules } : {}),
    });
    return out;
  }, []);

export default menuConfig;
